<template lang='pug'>
v-dialog(
	:model-value='show'
	@update:model-value='!$event ? emit("clicked", "nothing") : null'
	:max-width="isMobile ? '100%' : '1000'"
	max-height="80%"
	eager
	location="top"
	scrollable
	class="overflow: auto;"
).tw-overflow-auto

	.tw-card.tw-bg-white.tw-p-0.tw-border-0.tw-overflow-auto
		h1.tw-text-center.tw-py-5.tw-text-4xl.tw-border(v-if="hasADiscount" ) {{$t('sale.discount_code.title', 'Applicazione sconto')}}
		summary-travelsolution-details(
			v-for="(travelSolution, i) in props.travelSolutions"
			:travelSolution="travelSolution",
			:passengers="props.passengers",
			:searchCriteria="props.searchCriteria"
			:is-forward="isRoundTrip && 0 == i"
			:is-return="isRoundTrip && 1 == i"
		)

		.px-4.py-3.tw-flex.tw-items-center.tw-justify-between.tw-w-full.tw-bg-white(v-if="hasADiscount")
			v-btn.m-0(color='grey-darken-2' @click="emit('clicked', 'cancel')" variant="outlined") {{$t('common.cancel', 'Annulla')}}
			v-btn.m-0(color='primary-darken-1' @click="emit('clicked', 'ok')" variant="outlined") {{$t('dialogs.movement_details.proceed', 'Procedi al pagamento')}}

		.pr-4.py-3.tw-flex.tw-items-center.tw-justify-end.tw-w-full.tw-bg-white(v-else)
			v-btn.m-0(color='primary-darken-1' @click="emit('clicked', 'ok')" variant="outlined") OK
</template>

<script setup>
import {useI18n} from "vue-i18n";
import SummaryTravelsolutionDetails from "@/common-components/dialogs/summary-travelsolution-details.vue";
import {inject, provide} from "vue";
import {useDisplay} from "vuetify";


const i18n = useI18n();
const emit = defineEmits(['clicked']);
const props = defineProps({
	show: {
		type: Boolean,
		default: true
	},
	searchCriteria: Object,
	travelSolutions: Object,
	passengers: Array,
	isRoundTrip: Boolean,
	servicesMap: Object,
	passengersSelectionMap: Object,
	hasADiscount: {
		type: Boolean,
		default: false
	}
});
const isMobile = inject('isMobile');


provide('servicesMap', props.servicesMap);
provide('passengersSelectionMap', props.passengersSelectionMap);
provide('hasADiscount', props.hasADiscount);
</script>

<style scoped>
.v-overlay__content {
	overflow: auto;
}
</style>